import React from "react";

const NumberRadioCheckbox = ({
  id,
  name,
  onChange,
  checkedParam,
  max = 10,
  min = 1,
}) => {
  return (
    <div className="custom-checkbox small" id={id}>
      {Array.from({ length: max }).map((_, index) => {

        return (
          <div key={`numRadioCheck${id}${index}`}>
            <input
              type="radio"
              id={`check_${name}${index + min}`}
              name={name}
              value={index + min}
              onChange={onChange}
              checked={parseInt(checkedParam) === index + min}
            />
            <label htmlFor={`check_${name}${index + min}`}>{index + min}</label>
          </div>
        );
      })}
    </div>
  );
};

export default NumberRadioCheckbox;
